import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Quote, ArrowRight, HeartHandshake } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

const PLACEHOLDER = "https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?crop=entropy&cs=srgb&fm=jpg&q=80&w=940";

export function StoryCard({ s }) {
  return (
    <div className="group border border-slate-200 bg-white flex flex-col overflow-hidden" data-testid={`story-card-${s.id}`}>
      <div className="relative aspect-[4/3] bg-slate-100 overflow-hidden">
        <img src={mediaUrl(s.image) || PLACEHOLDER} alt={s.title} loading="lazy"
          onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {s.craft && <span className="absolute top-0 left-0 bg-emerald-600 text-white text-[10px] font-bold uppercase tracking-wider px-3 py-1.5">{s.craft}</span>}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-slate-900 leading-snug">{s.title}</h3>
        {(s.person || s.location) && <div className="text-xs text-slate-500 mt-1">{[s.person, s.location].filter(Boolean).join(" · ")}</div>}
        {s.quote && <p className="text-sm text-emerald-800 italic mt-3 flex gap-2"><Quote className="w-4 h-4 shrink-0 text-emerald-400" /> {s.quote}</p>}
        {s.summary && <p className="text-sm text-slate-500 mt-3 line-clamp-3">{s.summary}</p>}
      </div>
    </div>
  );
}

export function SuccessStoryStrip() {
  const { t } = useTranslation();
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/success-stories", { params: { featured: true } }).then((r) => setStories(r.data)).catch(() => {});
  }, []);
  if (!stories.length) return null;
  return (
    <section className="bg-slate-50 border-y border-slate-200" data-testid="home-success-stories">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="flex items-end justify-between mb-10 gap-4 flex-wrap">
          <div>
            <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-emerald-700"><HeartHandshake className="w-4 h-4" /> {t("arva.title")}</span>
            <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-slate-900 mt-2">{t("arva.storiesTitle")}</h2>
            <p className="text-slate-500 mt-2">{t("arva.storiesSubtitle")}</p>
          </div>
          <Link to="/arva-szakmak" className="hidden sm:inline-flex items-center gap-2 text-sm font-bold uppercase text-emerald-700 hover:gap-3 transition-all" data-testid="home-stories-all">
            {t("arva.storiesAll")} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {stories.slice(0, 3).map((s) => <StoryCard key={s.id} s={s} />)}
        </div>
      </div>
    </section>
  );
}
